import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import RequestAppointmentFormHero from '../../src/pages/appointment/OnlineAppointment2';
import heroImage from '../assets/rajslider/s0.png';
import heroImageOne from '../assets/rajslider/s1.jpeg';
import heroImageTwo from '../assets/rajslider/s2.png';
import heroImageThree from '../assets/rajslider/s3.png';
import heroImageFour from '../assets/rajslider/s4.png';
import heroImageFive from '../assets/rajslider/s5.png';
import heroImageSix from '../assets/rajslider/s6.png';

const carouselImages = [
   heroImage,
  heroImageOne,
  heroImageTwo,
  heroImageThree,
  heroImageFour,
  heroImageFive,
  heroImageSix
];

const Hero = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setActiveIndex((currentIndex) => (currentIndex + 1) % carouselImages.length);
    }, 10000);

    return () => window.clearInterval(intervalId);
  }, []);

  const handlePrevious = () => {
    setActiveIndex((currentIndex) =>
      currentIndex === 0 ? carouselImages.length - 1 : currentIndex - 1
    );
  };

  const handleNext = () => {
    setActiveIndex((currentIndex) => (currentIndex + 1) % carouselImages.length);
  };

  return (
    <HeroContainer>
      <BackgroundCarousel aria-hidden="true">
        {carouselImages.map((image, index) => (
          <CarouselBackground
            key={image}
            image={image}
            $isActive={index === activeIndex}
          />
        ))}

        <CarouselArrow type="button" onClick={handlePrevious} $direction="left" aria-label="Previous background image">
          &#8249;
        </CarouselArrow>
        <CarouselArrow type="button" onClick={handleNext} $direction="right" aria-label="Next background image">
          &#8250;
        </CarouselArrow>

        <DotNavigation>
          {carouselImages.map((image, index) => (
            <DotButton
              key={`dot-${image}`}
              type="button"
              onClick={() => setActiveIndex(index)}
              $isActive={index === activeIndex}
              aria-label={`Go to background image ${index + 1}`}
            />
          ))}
        </DotNavigation>
      </BackgroundCarousel>

      <Overlay />

      <HeroInner>
       {/*  <Content>
          <Title>Dr. Raj Kamal</Title>
          <Subtitle>
            A Dedicated Diabetes care clinic in Patna
          </Subtitle>
          <InsuranceInfo>
            CGHS, CAPF, CMRF, Ayushman Bharat और सभी TPA के अन्तर्गत निःशुल्क इलाज |
          </InsuranceInfo>

          <ButtonContainer>
            <StyledLink to="/about-us">READ MORE</StyledLink>
            <StyledLink to="/book-appointment" primary>Book OPD</StyledLink>
          </ButtonContainer>
        </Content> */}

      {/*   <FormWrapper>
          <RequestAppointmentFormHero />
        </FormWrapper> */}
      </HeroInner>
      
    </HeroContainer>
  );
}

export default Hero;

// -------------------- STYLES --------------------

const HeroContainer = styled.div`
  min-height:500px;
 /*  background: linear-gradient(135deg, #15306c, #149bd2); */
  position: relative;
  overflow: hidden;
  width: 100%;

  @media (max-width: 768px) {
    min-height: 0;
    aspect-ratio: 17 / 5;
  }
`;

const HeroInner = styled.div`
  position: relative;
  z-index: 2;
 
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 4rem;
  gap: 2rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    padding: 2rem 1rem;
    min-height: auto;
  }
`;

const Content = styled.div`
  flex: 1;
  max-width: 55%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem;
  position: relative;
  z-index: 3;

  @media (max-width: 1024px) {
    max-width: 100%;
    align-items: center;
    text-align: center;
  }

  @media (max-width: 480px) {
    padding: 0.5rem;
  }
`;

const FormWrapper = styled.div`
  flex: 1;
  max-width: 45%;
  position: relative;
  z-index: 3;
  border-radius: 16px;
  padding: 1.5rem;
  height: auto;

  @media (max-width: 1024px) {
    max-width: 600px;
    width: 100%;
    padding: 10px;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }

  @media (max-width: 480px) {
    width: 100%;
    padding: 0.8rem;
  }
`;

const Title = styled.h1`
  color: white;
  font-size: 4rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);

  @media (max-width: 1024px) {
    font-size: 2rem;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
`;

const Subtitle = styled.h2`
  color: white;
  font-size: 1.2rem;
  font-weight: 400;
  margin: 0;
  line-height: 1.5;
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const InsuranceInfo = styled.h2`
  color: #FFD700;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;


  @media (max-width: 768px) {
    justify-content: center;
  }

  @media (max-width: 480px) {
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
`;

const StyledLink = styled(Link)`
  background-color: ${props => props.primary ? '#FF6B35' : 'transparent'};
  color: white;
  padding: 10px 15px;
  text-decoration: none;
  border: 2px solid white;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  min-width: 180px;
  text-align: center;

  &:hover {
    background-color: ${props => props.primary ? '#E55A2B' : 'white'};
    color: ${props => props.primary ? 'white' : '#2C4B98'};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    min-width: 100px;
    padding: 5px 11px;
    flex-direction: row;
  }

  @media (max-width: 480px) {
    width: 100%;
    max-width: 250px;
    font-size: 10px;
    
  }
`;

const zoomBackground = keyframes`
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.06);
  }
`;

const BackgroundCarousel = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
`;

const CarouselBackground = styled.div`
  position: absolute;
  inset: 0;
  background-image: url(${({ image }) => image});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
  transform: scale(${({ $isActive }) => ($isActive ? 1.02 : 1)});
  transition: opacity 0.8s ease-in-out, transform 0.8s ease-in-out;
  animation: ${({ $isActive }) => ($isActive ? zoomBackground : 'none')} 5s linear forwards;
  will-change: opacity, transform;

  @media (max-width: 768px) {
    transform: none;
    animation: none;
  }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  /* background:
    linear-gradient(90deg, rgba(10, 24, 59, 0.84) 0%, rgba(18, 59, 125, 0.72) 42%, rgba(20, 155, 210, 0.56) 100%),
    linear-gradient(180deg, rgba(8, 18, 46, 0.3) 0%, rgba(8, 18, 46, 0.65) 100%); */
`;

const CarouselArrow = styled.button`
  position: absolute;
  top: 50%;
  ${({ $direction }) => ($direction === 'left' ? 'left: 1.5rem;' : 'right: 1.5rem;')}
  transform: translateY(-50%);
  z-index: 4;
  width: 52px;
  height: 52px;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 50%;
  background: rgba(6, 20, 48, 0.36);
  color: white;
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.25s ease, transform 0.25s ease;
  backdrop-filter: blur(6px);

  &:hover {
    background: rgba(6, 20, 48, 0.62);
    transform: translateY(-50%) scale(1.05);
  }

  @media (max-width: 768px) {
    width: 42px;
    height: 42px;
    font-size: 1.7rem;
    ${({ $direction }) => ($direction === 'left' ? 'left: 0.75rem;' : 'right: 0.75rem;')}
  }
`;

const DotNavigation = styled.div`
  position: absolute;
  left: 50%;
  bottom: 1.5rem;
  transform: translateX(-50%);
  z-index: 4;
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const DotButton = styled.button`
  width: ${({ $isActive }) => ($isActive ? '28px' : '11px')};
  height: 11px;
  border: 0;
  border-radius: 999px;
  background: ${({ $isActive }) => ($isActive ? '#ffffff' : 'rgba(255, 255, 255, 0.45)')};
  cursor: pointer;
  transition: width 0.25s ease, background-color 0.25s ease, opacity 0.25s ease;
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.85)};

  &:hover {
    background: rgba(255, 255, 255, 0.9);
  }
`;
